














































































































































































































































import HourSelector from '../../core/components/HourSelector.vue';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import Input from '../../core/components/Input.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getUniqueId,
    secondsValidation,
    getDateFormattedAsMoment,
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { dateTypes } from '../../core/models';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        DatePickerSingle,
        HourSelector,
        Input
    }
})
export default class ModalIgnorePeriod extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop({
        default() {
            return [];
        }
    })
    vehiclesOptions: Array<object>;
    @Prop({ default: null }) patchData: object | null;
    @Prop({ default: false }) saveOnMemory: boolean;
    @Prop({ default: null }) preselectedPeriods: null | object;
    modalTitle: string = 'Ignorar segmento de trabajo';
    dateRangeSelected: any = [];
    discardSegment: boolean = false;
    calculateWithoutPerformance: boolean = false;
    ignoreAllFromTelemetry: boolean = false;
    discardPerformance: boolean = false;
    discardHumidity: boolean = false;
    ignoreAllFromCSV: boolean = false;
    discardPerformanceCSV: boolean = false;
    discardHumidityCSV: boolean = false;
    vehicleSelectedRV: boolean = false;
    errorMsg: string = '';
    startDate: any = null;
    vehicleSelected: any = null;
    startHour: string = '';
    startSeconds: number = 0;
    endSeconds: number = 0;
    endDate: any = null;
    endHour: string = '';

    get validateSeconds() {
        return [secondsValidation, true];
    }

    get disableAllButtons() {
        return this.discardSegment;
    }

    get isPatch() {
        if (this.patchData !== null) {
            return true;
        } else {
            return false;
        }
    }
    preselectEndDate(value) {
        if (this.endDate == null) {
            this.updateEndDate(value);
        }
    }
    updateStartSeconds(value) {
        this.startSeconds = value;
    }
    updateEndSeconds(value) {
        this.endSeconds = value;
    }
    updateStartDate(value) {
        this.startDate = value;
    }
    updateStartHour(value) {
        this.startHour = value;
    }
    updateEndDate(value) {
        this.endDate = value;
    }
    updateEndHour(value) {
        this.endHour = value;
    }
    updateVehicleSelected(value) {
        this.vehicleSelected = value;
    }
    updateVehicleSelectedRV(value) {
        this.vehicleSelectedRV = value;
    }

    ignorePerformanceFromTelemetry(value) {
        this.uncheckIgnoreAllFromTelemetry();
        this.calculateWithoutPerformance = value;
    }

    clickDiscardSegment(value) {
        this.ignoreAllFromTelemetry = this.discardSegment;
        this.ignoreAllFromCSV = this.discardSegment;
        this.discardAllFromTelemetry(this.discardSegment);
        this.discardAllFromCSV(this.discardSegment);
    }

    discardAllFromTelemetry(value) {
        this.discardPerformance = value;
        this.discardHumidity = value;
        this.calculateWithoutPerformance = value;
    }

    discardAllFromCSV(value) {
        this.discardPerformanceCSV = value;
        this.discardHumidityCSV = value;
    }

    clickIgnoreAllFromTelemetry() {
        this.discardAllFromTelemetry(this.ignoreAllFromTelemetry);
    }

    clickIgnoreAllFromCSV() {
        this.discardAllFromCSV(this.ignoreAllFromCSV);
    }

    uncheckIgnoreAllFromTelemetry() {
        this.ignoreAllFromTelemetry = false;
    }

    uncheckIgnoreAllFromCSV() {
        this.ignoreAllFromCSV = false;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: 8000
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submit() {
        if (!this.isPatch) {
            if (!this.saveOnMemory) {
                this.postSegment();
            } else {
                this.addNewErrorLapse(this.getData);
                this.closeModal();
            }
        } else {
            if (!this.saveOnMemory) {
                this.patchSegment();
            } else {
                this.updateErrorLapse(this.getData);
                this.closeModal();
            }
        }
    }

    postSegment() {
        this.showLoadingDialog('Guardando...');
        InsuranceServices.postIgnoreSegment(this.getData)
            .then(res => {
                let msg = res['message'] !== undefined ? res['message'] : 'Se ha creado el periodo con error';
                this.showSuccessLoadingDialog(res, msg);
                this.addNewErrorLapse(res['errorlapse']);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'Ocurrio un error');
            });
    }

    patchSegment() {
        let idToPatch = this.patchData !== null ? this.patchData['id'] : null;

        if (idToPatch) {
            this.showLoadingDialog('Modificando...');
            InsuranceServices.patchIgnoreSegment(idToPatch, this.getData)
                .then(res => {
                    this.updateErrorLapse(res['data']['errorlapse']);
                    this.$_successLoadingDialog({
                        response: res.data,
                    });
                    this.closeModal();
                })
                .catch(err => {
                    this.showCatchLoadingDialog(err, 'Ocurrio un error');
                });
        }
    }

    preselectStartAndEndDate(errorLapseStartDate, errorLapseEndDate){
        let startSeconds = Number(errorLapseStartDate.slice(-2));
        let startDate = this.getParsedDate(errorLapseStartDate, dateTypes.dateYearFormatReverse);
        let startHour = this.getParsedDate(errorLapseStartDate, dateTypes.hoursAndMinutesFormat);
        let endDate = this.getParsedDate(errorLapseEndDate, dateTypes.dateYearFormatReverse);
        let endHour = this.getParsedDate(errorLapseEndDate, dateTypes.hoursAndMinutesFormat);
        let endSeconds = Number(errorLapseEndDate.slice(-2));
        this.updateStartSeconds(startSeconds);
        this.updateEndSeconds(endSeconds);
        this.updateStartDate(startDate);
        this.updateEndDate(endDate);
        this.updateStartHour(startHour);
        this.updateEndHour(endHour);
    }

    preselectVehicle(vehiclesList){
        if(vehiclesList.length == 1){
            this.updateVehicleSelected({
                id: vehiclesList[0]['id'],
                description: vehiclesList[0]['description']
            })
        }
        if(vehiclesList.length > 1){
            this.$_showAddPointOfInterest('Hay seleccionados segmentos de distintos vehículos')
        }
    }

    loadPatchData() {
        if (this.isPatch && this.patchData !== null) {
            this.modalTitle = 'Modificar segmento ignorado';
            let errorLapseStartDate = this.patchData['start_date'];
            let errorLapseEndDate = this.patchData['end_date'];
            this.preselectStartAndEndDate(errorLapseStartDate, errorLapseEndDate)
            this.calculateWithoutPerformance = this.patchData['calculate_without_performance'];
            this.discardHumidity = this.patchData['discard_humidity'];
            this.discardHumidityCSV = this.patchData['discard_humidity_csv'];
            this.discardPerformance = this.patchData['discard_performance'];
            this.discardPerformanceCSV = this.patchData['discard_performance_csv'];
            this.discardSegment = this.patchData['discard_segment'];
            if (this.patchData['vehicle'] && this.patchData['vehicle']['id']) {
                this.updateVehicleSelected(this.patchData['vehicle']);
            }
            // console.log('load patch data', this.patchData);
        } else {
            this.updateStartSeconds(0);
            this.updateEndSeconds(0);
            this.updateStartHour('00:00');
            this.updateEndHour('23:59');
        }
    }

    getParsedDate(date, format) {
        return getDateFormattedAsMoment(date, format, dateTypes.globalFilterDateFormat)
    }

    get getData() {
        return {
            vehicle: this.vehicleID !== -1 ? this.vehicleID : this.vehicleSelected['id'],
            start_date: this.getFullTimestamp(this.startDate, this.startHour, this.startSeconds),
            end_date: this.getFullTimestamp(this.endDate, this.endHour, this.endSeconds),
            discard_performance: this.discardPerformance,
            discard_humidity: this.discardHumidity,
            discard_performance_csv: this.discardPerformanceCSV,
            discard_humidity_csv: this.discardHumidityCSV,
            calculate_without_performance: this.calculateWithoutPerformance,
            discard_segment: this.discardSegment,
            id: this.isPatch && this.patchData !== null ? this.patchData['id'] : getUniqueId()
        };
    }

    get formIsValid() {
        this.setErrorForm('');
        if (this.vehicleID == -1 && this.vehicleSelected == null) {
            this.setErrorForm('No seleccionó el vehículo');
            return false;
        }

        if (this.startDate == null) {
            this.setErrorForm('No seleccionó Fecha de Inicio');
            return false;
        }

        if (this.endDate == null) {
            this.setErrorForm('No seleccionó Fecha de Fin');
            return false;
        }

        if (secondsValidation(this.startSeconds) !== true || secondsValidation(this.endSeconds) !== true) {
            this.setErrorForm('Hay campos inválidos');
            return false;
        }

        return true;
    }

    getFullTimestamp(date, hour, seconds) {
        seconds = seconds.toString().padStart(2, '0')
        return date + 'T' + hour + ':' + seconds;
    }

    @Emit()
    closeModal() {}

    @Emit()
    addNewErrorLapse(item) {
        return item;
    }

    @Emit()
    updateErrorLapse(item) {
        return item;
    }

    preselectIgnoredPeriods(){
        if(this.preselectedPeriods !== null){
            this.preselectStartAndEndDate(this.preselectedPeriods['start'], this.preselectedPeriods['end']);
            this.preselectVehicle(this.preselectedPeriods['vehicles'])
        }
    }

    mounted() {
        this.$nextTick(() => {
            this.loadPatchData();
            this.preselectIgnoredPeriods();
        });
    }
}
